import { ThemeType } from '../ThemeType';
import { addColoursToTheme } from '../addColoursToTheme';

export const lightTheme: ThemeType = addColoursToTheme({
  maxColumns: 3,
  body: '#F0F0F0',
  danger: '#fcebea',
  textDanger: '#E03C31',
  alert: '#FCF5E8',
  textAlert: '#E29E1A',
  neutral: '#FAFAFA',
  textNeutral: '#939598',
  neutralDark: '#F2F2F2',
  textNeutralDark: '#262A30',
  success: '#E6F6EF',
  textSuccess: '#07A35D',
  primary: '#fff',
  secondary: '#FAB302',
  textPrimary: '#2E2E2E',
  textSecondary: '#fff',
  banner: '#023E8A',
  button: '#023E8A',
  borderFaint: '#FAFAFA',
  borderDark: '#DFDFE0',
  alertMinHeight: '40px',
  sidebarWidth: '275px',
  buttonSubmitWidth: '150px',
  sidebarCollapsedWidth: '50px',
  sidebarHighlightDark: '#E29E1A',
  sidebarItemHeight: '30px',
  sidebarActiveBorderWidth: '5px',
  headerHeight: '62px',
  collapseHeaderHeight: '48px',
  bodyPadding: '135px',
  tableRowHeight: '35px',
  containerWidth: '1243px',
  signupContainerWidth: '670px',
  dropdownWidth: '275px',
  commisionInputWidth: '86px',
  buttonHeight: '40px',
  smallButtonHeight: '32px',
  termsAndConditionsHeight: '405px',
  scrollWidth: '6px',
  toggleButtonSpacing: '9px',
  smModalWidth: '412px',
  lgModalWidth: '588px',
  maxHeightModal: '640px',
  loginFormWidth: '508px',
  loginFormArrow: '70px',
  addressSearchClose: '7px',
  headerUserMenuWidth: '190px',
  smallFooterWidth: '1005px',
  collapseHeaderShadowHeight: '6px',
  ignoredDropdownWidth: '174px',
  maxNotesSectionHeight: '452px',
  taskStatusWidth: '85px',
  taskStageWidth: '185px',
  multiSelectChipLabelMaxWidth: '154px',
  esisHistoryHeight: '285px',
  taskEvidenceStatusWidth: '110px',
  taskEvidenceStatusDropdownWidth: '250px',
  taskEvidenceDocNameWidth: '270px',
  taskEvidenceDatetimeWidth: '130px',
  taskEvidenceActionsWidth: '55px',
  userIconSmSize: '10px',
  disbursementSummaryHeight: '502px',
  submitContentMaxHeight: '290px',
  colours: {
    primary: {
      1: '#002C6E',
      2: '#355C96',
      3: '#6986B1',
      4: '#839ABE',
      5: '#9CAFCC',
      6: '#B6C4D9',
      7: '#D0D9E7',
      8: '#EAEEF4',
      9: '#D5E5F9',
      10: '#DFECFF',
      11: '#EEF5FF',
    },
    secondary: {
      1: '#FD8625',
      2: '#EE6B00',
      3: '#FFA053',
      4: '#FEC596',
      5: '#FFD9BA',
      6: '#FFE8D5',
      7: '#FFF1E6',
    },
    tertiary: {
      1: '#3F2106',
      2: '#8E5F33',
      3: '#DABB9E',
      4: '#E1CCB8',
      5: '#E9DDD1',
      6: '#F4EDE6',
      7: '#F9F3ED',
    },
    neutral: {
      1: '#000000',
      2: '#2E2E2E',
      3: '#7A7A7A',
      4: '#949494',
      5: '#ADADAD',
      6: '#C7C7C7',
      7: '#E0E0E0',
      8: '#F0F0F0',
      9: '#F9F9F9',
      10: '#FFFFFF',
    },
    warning: {
      1: '#FD8625',
      2: '#FFF1E6',
      3: '#986FCC',
      4: '#F6F0FE',
    },
    danger: {
      1: '#DF4040',
      2: '#FDEFEE',
      3: '#FFDBD9',
    },
    success: {
      1: '#07A35D',
      2: '#E6F6EF',
      3: '#C8EFDE',
    },
    info: {
      1: '#4A85E3',
      2: '#F3F7FC',
    },
    link: {
      1: '#1566DE',
      2: '#C7831D',
      3: '#5F2AA2',
    },
    highlight: {
      1: '#FFE31E',
      2: '#FFF9D1',
    },
  },
  boxShadow: {
    1: '0px 4px 4px rgba(0, 0, 0, 0.15)',
    2: '0px 1px 4px 0px rgba(0, 0, 0, 0.10)',
  },
  borderWidth: {
    1: '1px',
    2: '2px',
    3: '4px',
  },
  borderRadius: {
    1: '4px',
    2: '8px',
  },
  padding: {
    1: '4px',
    2: '8px',
    3: '12px',
    4: '16px',
    5: '20px',
    6: '24px',
    7: '28px',
    8: '32px',
    9: '36px',
    10: '76px',
    11: '100px',
    12: '124px',
  },
  fontSize: {
    1: '12px',
    2: '14px',
    3: '16px',
    4: '18px',
    5: '20px',
    6: '22px',
    7: '24px',
    8: '32px',
    9: '40px',
    10: '44px',
    11: '48px',
  },
  fontWeight: {
    normal: '400',
    bold: '600',
    bolder: '700',
  },
  fontFamily: {
    1: 'Open Sans',
  },
  letterSpacing: {
    1: '1px',
  },
});
